import { getContext } from '@fiverr-private/fiverr_context';
import { translate } from '@fiverr-private/machine_translation';
import pathfinder from '@fiverr-private/pathfinder';

/**
 * Machine translate the required content
 
 * @param text
 * @param locale
 */
export const machineTranslate = ({ text, targetLocale, sourceInfo }) => {
    const url = pathfinder('logged_out_homepage_ugc_translate');
    const { abTests } = getContext();

    return translate({
        url,
        text,
        targetLocale,
        sourceInfo,
        retry: true,
        abTests,
    });
};
